import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCalendarFill';
/** Renders an SVG icon. */
const SvgCalendarFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 25a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V15a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm5-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm6 0a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm-6-4a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm6 0a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2zm6 0a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2z"
      />
      <path
        fill="currentColor"
        d="M4 11a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V9a3 3 0 0 0-3-3h-2v2a2 2 0 1 1-4 0V6h-6v2a2 2 0 1 1-4 0V6H7a3 3 0 0 0-3 3z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 9a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1m10 0a1 1 0 0 0 1-1V5a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1"
      />
    </svg>
  );
};
SvgCalendarFill.displayName = displayName;
export default SvgCalendarFill;
